module.exports = __webpack_public_path__ + "static/media/EX_logo.058d6769.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/EX_logo.svg
// module id = ./src/common/images/EX_logo.svg
// module chunks = 1